import styles from "./Organisations.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { OrganisationTable } from '../../components/OrganisationTable';
import { UserContext } from '../../context/UserContext';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

export const Organisations = () => {
    const userContext = useContext(UserContext)
    if(userContext?.organisation?.id !== 1) {
        return <Navigate to='/library/home' />
    }


    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Organisations" subtitle=""/>
            <section className={styles.navigate}>
                <OrganisationTable></OrganisationTable>
            </section>
        </div>
    )
};
